import LocalizedStrings from "react-localization";

export const textMap = new LocalizedStrings({
	kr: {
		promotion_badge:"베타 한정가",
		promotion_text:"하루 2,980원으로 미니맵에서 광고를 집행해보세요!",
		promotion_link:"광고 올리러 가기",
		header_why:"왜 미니맵인가요?",
		header_price:"가격정보",
		header_faq:"FAQ",
		header_ask:"문의하기",
		header_start_button:"광고 시작하기",
		top_intro_text:"하루 {0}으로 유저의\n반응을 알아보세요",
		top_intro_text_mobile:"하루 {0}으로\n유저의 반응을\n알아보세요",
		top_intro_price:"2,980원",
		top_intro_button:"미니맵에 광고하기",
		top_intro_comment_1:"난이도가 쉽지 않습니다! ㅎㅎ",
		top_intro_comment_2:"다운받아서 해봤는데 잼있네요",
		top_intro_comment_3:"미니맵에서 계속 보니 궁금해서 깔아봐요.",
		about_sponsored_title:"미니맵 {0} 광고란?",
		about_sponsored_title_2:"스폰서드",		
		about_sponsored_text:"사용자들이 가장 많이 방문하는\n피드 메뉴 사이에 들어가\n노출시간이 길고 거부감이 적은\n오가닉 콘텐츠 느낌의 광고입니다.",
		about_sponsored_button:"더 알아보기",
		why_minimap_title:"왜 {0}인가요?",
		why_minimap_title_2:"미니맵",
		w_m_section_1_title:"게임에 관심있는 분들만\n{0}",
		w_m_section_1_title_2:"모여 계십니다",
		w_m_section_1_desc_1:"내 게임을 알리고 싶은데\n막막하셨다구요?",
		w_m_section_1_desc_2:"어느 채널에 집행할지,\n괜히 돈만 버리는 것은 아닌지 고민하셨다면\n미니맵이 정답입니다.",
		w_m_section_1_button:"광고 올리러 가기",
		w_m_section_2_title:"{0} 진입 장벽",
		w_m_section_2_title_2:"낮은",
		w_m_section_2_desc_1:"게임을 알릴 수 있는 채널 자체가\n너무 한정되어 있습니다.",
		w_m_section_2_desc_2:"미니맵에서 오직\n하드코어 게이머만을 대상으로\n당신의 게임을 알리세요.",
		w_m_section_2_info_1:"게임 다운로드 경로",
		w_m_section_2_info_2:"출처 : 2019 대한민국 게임 백서, 한국콘텐츠진흥원",
		w_m_section_2_info_3:"Playstore, App store의 게임 순위",
		w_m_section_2_info_4:"친구의 직접 추천",
		w_m_section_2_info_5:"포털 광고",
		w_m_section_2_info_6:"게임 플레이 영상",
		w_m_section_2_info_7:"카톡 추천 메세지",
		w_m_section_2_info_8:"카톡 게임에서",
		w_m_section_2_info_9:"TV 광고",
		w_m_section_2_info_10:"SNS",
		w_m_section_2_info_11:"(단위:%, n=1,794, 중복응답)",		
		w_m_section_2_button:"미니맵에 내 게임 알리기",
		w_m_section_3_title:"고객을 {0}",
		w_m_section_3_title_2:"알아가세요",
		w_m_section_3_desc_1:"광고 후 받아보는\n노출 수, 클릭 수 등의 보고서.",
		w_m_section_3_desc_2:"그래서 우리 게임을\n누가 플레이한다는 걸까요?",
		w_m_section_3_desc_3:"미니맵에서는 여러분의 게임에 관심 있는\n잠재고객들과 직접 소통하실 수 있습니다.",
		w_m_section_3_button:"자연스럽게 고객들 만나러 가기",
		w_m_comment_1:"다양한 캐릭터들의 매력과 예쁜\n스킨들은 충분히 이목을 끌만함",
		w_m_comment_2:"매칭시간이 짧아 잠깐 짬날 때\n하기 좋은 게임",
		w_m_comment_3:"2일차인데 재미지네요\n가볍게 한두판만해야지 하고 켰다가\n30분 순삭ㅠ",
		user_stat_title:"미니맵 {0}들은?",
		user_stat_title_2:"유저",
		user_stat_desc_1:"인평균 게임 평가 개수 {0}",
		user_stat_desc_2:"월간 순 이용자 {0}",
		user_stat_desc_3:"월간 페이지뷰 {0}",
		user_stat_value_1:"{0}개",
		user_stat_value_2:"{0}명",
		user_stat_value_3:"{0}",
		user_stat_info:"2020년 05월 기준",
		price_title:"가장 중요한 {0}은?",
		price_title_2:"가격",
		price_desc:"베타 한정 프로모션을 놓치지 마세요",
		price_tier_title_1:"Basic",
		price_tier_title_2:"Standard",
		price_tier_title_3:"Premium",
		price_tier_old_price_1:"32,000원",
		price_tier_price_1:"20,000원",
		price_tier_price_info_1:"(1주 단위)",
		price_tier_price_2:"개별문의",
		price_tier_price_3:"개별문의",
		price_tier_desc_1:"미니맵의 뛰어난 광고시스템을 적은 금액에 체험해보고 싶은 분들을 위한 플랜이에요.",
		price_tier_desc_2:"가장 중요한 홈화면 배너가 포함된 플랜이에요.",
		price_tier_desc_3:"노출이 자꾸 되면 관심이 갈 수 밖에 없어요. 미니맵 곳곳에 노출되길 원하시면 이 플랜을 선택하세요!",
		price_tier_check_1:"스폰서드 피드 1슬롯",
		price_tier_check_2:"메인 상단 DA 1슬롯",
		price_tier_check_3:"순위 DA 1슬롯",
		price_tier_check_4:"컬렉션 DA 1슬롯",
		price_tier_check_5:"알림 메세지 발송",
		price_tier_check_6:"광고 보고서 제공",
		price_tier_check_7:"베타 한정 쿠폰 제공!",
		price_tier_check_8:"* ‘스폰서드 피드’ 결제기간만큼 추가로 쓸 수 있는 쿠폰을 지급 (기간종료 후 30일 이내 신청 가능)",
		price_tier_button:"이 요금 선택",
		price_tier_button_2:"이 요금 문의",
		price_tier_button_coming:"준비중",
		price_tier_badge:"Beta\n한정가",
		process_title:"어떻게 {0} 되나요?",
		process_title_2:"진행",
		process_item_title_1:"미니맵에 계정 만들기",
		process_item_title_2:"광고 권한 신청",
		process_item_title_3:"광고 게시물 만들기",
		process_item_title_4:"미니맵에 게재요청",
		process_item_title_5:"게재 승인",
		process_item_title_6:"모니터링 및 보고서 받기",
		process_item_desc_1:"가입하신 미니맵 계정으로\n광고가 나갑니다.\n믿음직한 프로필을 완성해 보세요.",
		process_item_desc_2:"이 페이지에서 [광고 시작하기] 버튼을 눌러\n광고 권한과 집행기간을 요청하세요!",
		process_item_desc_3:"내 게임에 관심을 가질 수 있을 만한\n매력적인 광고 게시물을\n직접 만드세요.",
		process_item_desc_4:"작성된 광고 게시물의\n‘게재 요청’ 버튼을 눌러\n미니맵에 검토를 요청합니다.",
		process_item_desc_5:"승인되면 푸시 알림이 옵니다.\n모든 준비가 끝났어요.",
		process_item_desc_6:"광고가 진행되는 동안\n잠재고객의 반응을 살펴보세요.\n보고서는 이메일로 주 1회 발송됩니다.",
		faq_title:"{0}이 있으신가요?",
		faq_title_2:"질문",
		faq_q_1:"광고소재(게시글)를 직접 만들어야 되나요?",
		faq_q_2:"성과 지표를 받아볼 수 있나요?",
		faq_q_3:"광고소재는 어떻게 만드나요?",
		faq_q_4:"광고 계정으로 할 수 있는 활동에 제한이 있나요?",
		faq_q_5:"광고 소재를 모바일로 만들 수는 없나요?",
		faq_q_6:"미니맵의 다른 영역에는 광고 못하나요?",
		faq_a_1:"네. 직접 만드셔야 됩니다.\n고객에게 어필할 수 있을 만한 멋진 크리에이티브를 제작해 주세요.",
		faq_a_2:"보고서는 매주 1회 등록하신 이메일로 발송됩니다.",
		faq_a_3:"텍스트, 랜딩 링크, 이미지(가로 548px, 세로 286px 이상 권장)만 있으면 쉽게 만드실 수 있습니다.",
		faq_a_4:"광고 게시글을 작성할 수 있다는 추가 권한을 제외하고는, 일반 계정과 동일하게 게시글 작성 및 댓글 작성이 모두 가능합니다.",
		faq_a_5:"예, 아쉽지만 관련 기능은 현재 개발중입니다. 빠른 시일 내에 지원할 수 있도록 노력하겠습니다.",
		faq_a_6:"가능하십니다. 하단 '문의하기'를 통해 별도 문의하시면 빠르게 답변 드리겠습니다.",
		footer_title:"하루 {0}으로\n유저들의 반응을 알아보세요",
		footer_title_mobile:"하루 {0}으로\n유저들의 반응을\n알아보세요",
		footer_title_2:"2,980원",
		footer_button:"미니맵에 광고하기",
		footer_button_1:"미니맵 유저 만나기",
		footer_button_2:"미니맵 가입하기",
		footer_button_3:"문의하기",
	},
	en: {
		
	},
});
export const imageMap = new LocalizedStrings({
	kr: {		
		full_logo:"full_logo.png",
		top_intro:"top_intro.png",
	},
	en: {
		
	},
});

class Localization {
	static setLanguage(lang) {

		// if(lang == null) {
		// 	lang = Cookie.get("language", null);
		// 	if(lang == null) {
		// 		lang = adminString.getInterfaceLanguage();
		// 	}
	
		// 	if(lang.indexOf("kr") > -1 || lang.indexOf("ko") > -1) {
		// 		lang = "kr";
		// 	} else {
		// 		lang = "kr"; // 일단 한글버전만
		// 	}
		// }

		textMap.setLanguage(lang);
		imageMap.setLanguage(lang);
	}
	// static getLanguage() {
	// 	return adminString.getLanguage();
	// }
}

export default Localization;
